export const RohdeSchwarz_FPS7 = {
  DEFAULT_PORT: '5025',
  RBW_VALUES: [
    'AUTO',
    '3 MHZ',
    '1 MHZ',
    '500 KHZ',
    '300 KHZ',
    '200 KHZ',
    '100 KHZ',
    '50 KHZ',
    '30 KHZ',
    '20 KHZ',
    '10 KHZ',
    '5 KHZ',
    '3 KHZ',
    '2 KHZ',
    '1 KHZ',
    '500 HZ',
    '300 HZ',
    '200 HZ',
    '100 HZ',
    '50 HZ',
    '30 HZ',
    '20 HZ',
    '10 HZ',
    '5 HZ',
    '3 HZ',
    '2 HZ',
    '1 HZ',
  ],
  VBW_VALUES: [
    'AUTO',
    '3 MHZ',
    '1 MHZ',
    '500 KHZ',
    '300 KHZ',
    '200 KHZ',
    '100 KHZ',
    '50 KHZ',
    '30 KHZ',
    '20 KHZ',
    '10 KHZ',
    '5 KHZ',
    '3 KHZ',
    '2 KHZ',
    '1 KHZ',
    '500 HZ',
    '300 HZ',
    '200 HZ',
    '100 HZ',
    '50 HZ',
    '30 HZ',
    '20 HZ',
    '10 HZ',
    '5 HZ',
    '3 HZ',
    '2 HZ',
    '1 HZ',
  ],
  PREAMP_VALUES: ['OFF', 'ON'],
  ATTEN_VALUES: ['AUTO', '0 dB', '10 dB', '20 dB', '30 dB', '40 dB', '50 dB'],
  SWEEP_TIME_ENABLED: true,
  DETECTION_MODE_VALUES: [
    'Normal',
    'Sample',
    'Positive',
    'Negative',
    'Average',
  ],
  IMAGES: {
    connected: 'unit-rx4-connected.png',
    disconnected: 'unit-rx4-disconnected.png',
    lostConnection: 'unit-rx4-lostconnection.png',
  },
  parseIdnResponse: (idnResponse: string) => {
    const splitResponse = idnResponse.split(',');

    return {
      model: splitResponse[1],
      serial: splitResponse[2].split('/')[1],
    };
  },
};
